<template>
  <el-form style="width: 500px" ref="form" :model="formData" :hide-required-asterisk="disabled">
    <el-form-item>
      <nutrition-ingredient
          v-for="(i, index) in formData.nutritionList"
          :key="index"
          :food="i"
          :support-lang-list="langList"
          :disabled="disabled"
          @remove="handleRemove(index)"
          :lang="lang"  />

      <span style="color: orangered">{{$t('lang.如果未知可以跳过')}}</span>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" style="width: 100%" icon="el-icon-circle-plus-outline" @click="handleAddNutrition"
                 v-if="!disabled">{{$t('lang.添加营养成分')}}
      </el-button>
    </el-form-item>
    <el-form-item>
      <el-button @click="$router.back()" v-if="disabled">{{$t('lang.返回')}}</el-button>
      <template v-else>
        <el-button @click="$emit('save')">{{ $t('lang.保存') }}</el-button>
        <el-button v-if="$store.getters.hasTranslate" @click="$emit('translate')">{{$t('lang.翻译')}}</el-button>
      </template>
      <el-button type="primary" @click="$emit('lastStep')">{{$t('lang.上一步')}}</el-button>
      <el-button type="primary" @click="$emit('next')">{{$t('lang.下一步')}}</el-button>
    </el-form-item>
  </el-form>

</template>

<script>
import NutritionIngredient from "./NutritionIngredient";

export default {
  name: "RecipeNutritionForm",
  components: {NutritionIngredient},
  props: {
    status: {
      type: String,
      default: 'add'
    }
  },
  data() {
    return {
      inputNum: 1,
      formData: {
        nutritionList: [],
      },
      langList: [],
      lang: '',
      disabled: false
    }
  },
  watch: {
    status: {
      handler(state) {
        if (state == 'detail') {
          this.disabled = true;
        }
      },
      immediate: true,
      deep: true,
    },
    "formData.nutritionList": {
      handler(list) {
        let nutritionList = list.map((i, index) => {
          i.number = (index + 1) + "";
          return i;
        })
        this.$store.commit("CHANGE_RECIPE", {nutritionList});
      },
      immediate: false,
      deep: true,
    }
  },
  methods: {
    // 同步其他语言
    handleInputBlur() {
      this.formData.nutritionList.forEach(e => {
        for (let key in e) {
          if (e[key] instanceof Object && key !== this.lang) {
            if(e[this.lang].amount && !e[key].amount) e[key].amount = e[this.lang].amount;
            if(e[this.lang].unit && !e[key].unit) e[key].unit = e[this.lang].unit;
            if(e[this.lang].nutritionName && !e[key].nutritionName) e[key].nutritionName = e[this.lang].nutritionName;
          }
        }
      })
    },

    handleGetData() {
      let {supportLangList, lang, nutritionList}= this.$store.state.recipe;
      this.langList = supportLangList;
      this.lang = lang;
      let list = nutritionList || [];
      if (list.length) {
        this.formData.nutritionList = this.handleEchoInput(list);
      } else {
        this.handleAddNutrition();
      }
    },

    // 根据语言列表回显input
    handleEchoInput(list) {
      return list.map(item => {
        let keys = Object.keys(item);
        this.langList.forEach(i => {
          if(!keys.includes(i)) {
            item[i] = {
              nutritionName: "",
              amount: null,
              unit: "",
            }
          }
        })
        return item;
      })
    },

    // 删除营养
    handleRemove(index) {
      this.formData.nutritionList.splice(index, 1);
    },

    //添加模板
    handleAddNutrition() {
      let obj = {}
      this.langList.forEach(i => {
        obj[i] = {
          amount: '',  // 数量
          unit: '', // 单位
          nutritionName: '',  // 营养名称
        }
      });
      this.formData.nutritionList.push(obj);
    },
  },
  computed: {
    unitList() {
      return this.$store.state.recipeUnit;
    }
  },
  async created() {
    this.handleGetData();
    this.$bus.$on("translateRecipe", () => {
      this.handleGetData();
    });
  }
}
</script>

<style scoped>

.input-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.input-icon {
  color: red;
  font-size: 26px;
  margin-left: 14px;
}

</style>
